function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvg: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    throwIfNamespace: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m4.167 8.377c0 6.917-3.583 11.667-3.583 15s1.916 10.333 17.249 10.333 17.583-9.417 17.583-13.083c.001-17.167-31.249-24.5-31.249-12.25z",
    fill: "#f3f3f1",
    "data-original": "#f3f3f1",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#a4afc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.29 3.321h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 5.585 21.123)",
    fill: "#a4afc1",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.901 2.467h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 4.693 18.266)",
    fill: "#a4afc1",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.967 6.533h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 3.011 22.336)",
    fill: "#a4afc1",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m26.25 15c0 2.28-.92 4.34-2.42 5.84-.98.98-1.58 2.26-1.58 3.65v1.26h-8.5v-1.26c0-1.39-.61-2.68-1.59-3.66-1.79-1.79-2.76-4.41-2.29-7.23.58-3.58 3.59-6.41 7.2-6.8 4.98-.54 9.18 3.33 9.18 8.2z",
    fill: "#efefef",
    "data-original": "#efefef",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m22.25 25.75v1.54c0 1.08-.87 1.96-1.94 1.96h-4.6c-1.08 0-1.96-.88-1.96-1.96v-1.54z",
    fill: "#ffffff",
    "data-original": "#2fdf84",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m14.41 20.83c-1.79-1.79-2.76-4.41-2.29-7.23.569-3.509 3.473-6.291 6.988-6.768-.659-.088-1.339-.108-2.038-.032-3.61.39-6.62 3.22-7.2 6.8-.47 2.82.5 5.44 2.29 7.23.98.98 1.59 2.27 1.59 3.66v1.26h2.25v-1.26c0-1.39-.61-2.68-1.59-3.66z",
    fill: "#d5dbe1",
    "data-original": "#d5dbe1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m16 27.29v-1.54h-2.25v1.54c0 1.08.88 1.96 1.96 1.96h2.25c-1.08 0-1.96-.88-1.96-1.96z",
    fill: "#dddddd",
    "data-original": "#00b871",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m22.25 26.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m20.31 30h-4.6c-1.494 0-2.71-1.216-2.71-2.71v-2.804c0-1.128-.487-2.237-1.37-3.124-2.073-2.08-2.986-4.953-2.505-7.883.636-3.875 3.943-6.997 7.865-7.424 2.598-.285 5.091.513 7.02 2.242 1.9 1.705 2.99 4.148 2.99 6.703 0 2.406-.937 4.668-2.639 6.371-.878.879-1.361 1.984-1.361 3.114v2.805c0 1.494-1.207 2.71-2.69 2.71zm-2.3-22.5c-.284 0-.57.016-.858.047-3.264.356-6.018 2.953-6.546 6.176-.402 2.448.358 4.847 2.087 6.581 1.166 1.169 1.808 2.655 1.808 4.183v2.804c0 .667.543 1.21 1.21 1.21h4.6c.656 0 1.19-.543 1.19-1.21v-2.805c0-1.53.64-3.013 1.801-4.175 1.417-1.419 2.198-3.306 2.198-5.311 0-2.129-.909-4.166-2.493-5.586-1.393-1.25-3.142-1.914-4.997-1.914z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m17.25 19c-.056 0-.112-.006-.169-.019-.404-.093-.655-.496-.563-.899l1.5-6.5c.093-.403.495-.653.899-.563.404.093.655.496.563.899l-1.5 6.5c-.079.348-.388.582-.73.582z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m21.25 18c-.205 0-.409-.083-.558-.248-.277-.308-.252-.782.056-1.06l1.881-1.692-1.881-1.692c-.308-.277-.333-.751-.056-1.06.279-.308.751-.333 1.06-.056l2.5 2.25c.158.143.248.346.248.558s-.09.415-.248.558l-2.5 2.25c-.144.129-.323.192-.502.192z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m14.75 18c-.179 0-.358-.063-.502-.192l-2.5-2.25c-.158-.143-.248-.346-.248-.558s.09-.415.248-.558l2.5-2.25c.309-.276.781-.252 1.06.056.277.308.252.782-.056 1.06l-1.881 1.692 1.881 1.692c.308.277.333.751.056 1.06-.149.165-.353.248-.558.248z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaBulb);
export default __webpack_public_path__ + "static/media/idea-bulb.7abea1308a3bf2c7c1659dc473295271.svg";
export { ForwardRef as ReactComponent };